const WHITE_COLORS = ['#FFFFFF', '#FAFAFA', '#FCFCFC'];
export const isWhiteByHex = color => {
  return WHITE_COLORS.includes(color.toUpperCase());
};